const updateAuthErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateAuthErrors;
